<template>
  <div class="page-wrapper section-space--inner--120">
    <div class="blog-section">
      <div class="container">
        <div class="row">
          <div class="col-lg-8 order-1 order-lg-2">
            <h2
              v-if="$route.params.slug"
              style="text-align: center;margin-bottom: 20px;"
            >
              {{ getCurrentCategory }}
            </h2>
            <div class="row">
              <div
                class="col-sm-6"
                v-for="article in articles"
                :key="article.id"
              >
                <BlogPost :blog="article" />
              </div>
            </div>
            <div class="row ">
              <div class="col">
                <ul class="page-pagination section-space--top--30">
                  <li v-if="meta.current_page != 1">
                    <a @click="loadPage(meta.current_page - 1)">
                      <i class="fa fa-angle-right"></i> قبلی</a
                    >
                  </li>
                  <li v-if="meta.current_page != 1">
                    <a @click="loadPage(meta.current_page - 1)">{{
                      meta.current_page - 1
                    }}</a>
                  </li>

                  <li class="active">
                    <a>
                      {{ meta.current_page }}
                    </a>
                  </li>

                  <li v-if="meta.current_page != meta.last_page">
                    <a @click="loadPage(meta.current_page + 1)">{{
                      meta.current_page + 1
                    }}</a>
                  </li>

                  <li v-if="meta.current_page != meta.last_page">
                    <a @click="loadPage(meta.current_page + 1)"
                      ><i class="fa fa-angle-left"></i> بعدی</a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-4 order-2 order-lg-1">
            <BlogSidebar :blogSidebar="getArticleCategories" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import data from "../../data/blog.json"
import { NewsService } from "@/store/services/news.service.js"
import { articleCategoryStore } from "@/store/Modules/articleCategory.js"
import { mapState } from "pinia"
import { mapStores } from "pinia"
import { mapActions } from "pinia"
import BlogSidebar from "@/components/sections/BlogSidebar"
import BlogPost from "@/components/BlogPost"
export default {
  components: {
    BlogSidebar,
    BlogPost,
  },
  data() {
    return {
      data,
      articles: [],
      page: 1,
      meta: [],
      currentCategory: {},
    }
  },
  computed: {
    ...mapState(articleCategoryStore, ["getArticleCategories"]),
    getCurrentCategory() {
      if (this.$route.params.slug) {
        let data = this.getArticleCategories
        for (const item in data) {
          if (data[item].slug == this.$route.params.slug) return data[item].name
        }
      }
      return null
    },
  },
  watch: {
    "$route.params": {
      handler(newValue) {
        this.loadPage(this.page)
      },
    },
  },
  methods: {
    ...mapActions(articleCategoryStore, ["getArticleCategoriesAction"]),
    loadPage(page) {
      this.$router.push({ query: { page: page } })
      this.page = page
      this.loadApi(page)
    },
    loadApi(page) {
      if (this.$route.params.slug) {
        NewsService.list(this.page, 10, this.$route.params.slug).then(
          ({ data }) => {
            this.articles = data.data
            this.meta = data.meta
          }
        )
      } else {
        NewsService.list(this.page).then(({ data }) => {
          this.articles = data.data
          this.meta = data.meta
        })
      }
    },
  },
  mounted() {
    this.getArticleCategoriesAction()
    if (this.$route.query.page) {
      this.page = this.$route.params.page
    } else {
      this.page = 1
    }
    this.loadApi(this.page)
  },
}
</script>
